import RecentreButton from './RecentreButton';

export default RecentreButton;
